import Utils from '@/common/utils/utils';
import { formatUserDateTime } from '@/common/utils/timezoneUtils';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { Tooltip } from '@material-ui/core';
import trI18n from '@/common/utils/trI18n';
import { tr, trLabel } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import { PropTypes } from 'prop-types';
import { useRecoilValue } from 'recoil';
import { userAtom } from '@/state/atom/userAtom';

FooterEmailTicket.propTypes = {
    detailTicket: PropTypes.any,
    formDetail: PropTypes.any
};

export default function FooterEmailTicket({
    detailTicket,
    formDetail
}) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const userDetail = useRecoilValue(userAtom);

    return (
        <div className="detail-ticketKnowledge-info">
            <div className="detailTicket-footer">
                <div className="detail-ticketKnowledge-form">
                    <div className="detail-ticketKnowledge-form-label">
                        {trI18n('LABEL-FORMAT-NAME')} 
                    </div>
                    <OverFlowTooltipWithTabsMui value={trLabel(detailTicket?.usingFormName)} />
                </div>
                <div className="detail-ticketKnowledge-info-child">
                    <div className="detail-ticketKnowledge-form">
                        {trI18n('CM-LABEL-FORMAT-ID')} :
                        <span
                            className="id-detail-ticket-copy"
                            onClick={async () => {
                                navigator.clipboard
                                    .writeText(formDetail?.id)
                                    .then(() => {})
                                    .catch(err => {});
                            }}
                        >
                            <img src="/assets/image/icon-copy.svg" alt="" />
                        </span>
                        <span className="field-form-id">{formDetail?.id}</span>
                    </div>
                </div>
                <div className="detail-ticketKnowledge-info-child">
                    <div className="detail-ticketKnowledge-info-time">
                        {tr('投稿日時：')}<span>{formatUserDateTime(detailTicket?.createdAt, 'YYYY/MM/DD HH:mm', userDetail?.userSetting)}</span>
                    </div>
                    <div className="detail-ticketKnowledge-info-user">
                        {tr('投稿ユーザー：')}
                        <Tooltip title={detailTicket?.createrUserName}>
                            <span
                                style={{
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    width: '55px'
                                }}
                            >
                                {detailTicket?.createrUserName}
                            </span>
                        </Tooltip>
                    </div>
                </div>

                <div className="detail-ticketKnowledge-info-child">
                    <div className="detail-ticketKnowledge-info-time">
                        {tr('更新日時：')}
                        <span>
                        {formatUserDateTime(detailTicket?.updatedAt, 'YYYY/MM/DD HH:mm', userDetail?.userSetting)}
                        </span>
                    </div>
                    <div className="detail-ticketKnowledge-info-user">
                        {tr('更新ユーザー：')}
                        <Tooltip title={detailTicket?.updatorUserName}>
                            <span
                                style={{
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    width: '55px'
                                }}
                            >
                                {detailTicket?.updatorUserName}
                            </span>
                        </Tooltip>
                    </div>
                </div>
                <div className="id-detail-ticket-footer">
                    <span className='id-detail-ticket-title'>{trI18n('USER04LB004')} :</span>
                    <span 
                        className="id-detail-ticket-copy" 
                        onClick={ async () => {
                            navigator.clipboard.writeText(detailTicket?.id)
                            .then(() => {})
                            .catch((e) => console.log('copy ticketId e :>> ', e));
                        }}
                    >
                        <img src="/assets/image/icon-copy.svg" alt=""/>
                    </span>
                    <span id="ticketId">{detailTicket?.id}</span>
                </div>
            </div>
        </div>
    );
}
